import { createAction } from '@wix/communities-blog-client-common';
import { getMultilingualLanguage } from '../../services/get-current-site-language';

export const FETCH_PAYWALL_BANNER_SUCCESS = 'paywallBanner/FETCH_SUCCESS';

const fetchPaywallBannerRequest = createAction('paywallBanner/FETCH_REQUEST');
const fetchPaywallBannerSuccess = createAction(FETCH_PAYWALL_BANNER_SUCCESS);
const fetchPaywallBannerFailure = createAction('paywallBanner/FETCH_FAILURE');

export const fetchPaywallBanner = () => {
  return (dispatch, _getState, { paywallRequest, wixCodeApi }) => {
    const language =
      getMultilingualLanguage(wixCodeApi) || wixCodeApi.site.language;
    dispatch(fetchPaywallBannerRequest());
    return paywallRequest(
      `/banners/default?lang=${language}&site=${wixCodeApi.location.baseUrl}`,
    )
      .then(
        (payload) => dispatch(fetchPaywallBannerSuccess(payload)),
        () => dispatch(fetchPaywallBannerFailure()),
      )
      .then(() => Promise.resolve());
  };
};
